import { render, staticRenderFns } from "./edutalk-identity.vue?vue&type=template&id=5c493fa0"
import script from "./edutalk-identity.vue?vue&type=script&lang=js"
export * from "./edutalk-identity.vue?vue&type=script&lang=js"
import style0 from "./edutalk-identity.vue?vue&type=style&index=0&id=5c493fa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports